export namespace Contract {
  export const SOURCE_TYPE = {
    AccountDeleted: 'accountDeleted',
    AutoCancelContract: 'autoCancelContract',
    ChangeContract: 'changeContract',
    ContractAutoPayment: 'contractAutoPayment',
    ContractManualPayment: 'contractManualPayment',
    ContractWithoutPayment: 'contractWithoutPayment',
    ExpiredPaymentLimit: 'expiredPaymentLimit',
    FailedContractAutoPayment: 'failedContractAutoPayment',
    FailedContractAutoPaymentDetected: 'failedContractAutoPaymentDetected',
    RequestForCancelContract: 'requestForCancelContract',
    StartManualPayment: 'startManualPayment',
  } as const

  export type SourceTypeType = typeof SOURCE_TYPE[keyof typeof SOURCE_TYPE]

  export const STATUS = {
    Ready: 'ready',
    Expired: 'expired',
    Initialized: 'initialized',
    Reserved: 'reserved',
    Completed: 'completed',
    Canceled: 'canceled',
    Error: 'error',
  } as const

  export type StatusType = typeof STATUS[keyof typeof STATUS]
}
